export default __webpack_public_path__ + "static/media/1-oz-gold-american-eagle-50-coin-bu-random-year--132083449145199349.8a23b216.jpg";